import React, {Component} from 'react'
import { defineMessages } from 'react-intl'
import { injectIntl, FormattedMessage } from 'react-intl'
import './bracket.scss'
import InputUnitOfMeasure from '../../../common/unit-of-measure/input.component.jsx'
import MoneyInputForm from "../../../common/form/moneyinput.component.jsx"
import BillingMethodCostLabel from "../../billing-method/costlabel.component.jsx"
import BillingMethodPriceLabel from "../../billing-method/pricelabel.component.jsx"
import PricingHelper from '../../PricingHelper.jsx';
const uuidv4 = require('uuid/v4')

class PricingBracketForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            id: '',
            fromMeasure: '',
            toMeasure: '',
            cost: '',
            price: '',
            monthlyCost: '',
            monthlyPrice: '',
            yearlyCost: '',
            yearlyPrice: '',
            pricingStrategy: '',
            sequence: '',
            currency: '',
            currentCurrency: '',
            multiCurrencyPricing: [],
            index: 0,
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteValue = this.deleteValue.bind(this)
        this.changeValue = this.changeValue.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
    }

    componentDidMount() {
        const value =  this.props.value || {}
        this.setState({
            id: value.id || '',
            fromMeasure: value.fromMeasure || '',
            toMeasure: value.toMeasure || '',
            cost: value.cost || '',
            price: value.price || '',
            monthlyCost: value.monthlyCost || '',
            monthlyPrice: value.monthlyPrice || '',
            yearlyCost: value.yearlyCost || '',
            yearlyPrice: value.yearlyPrice || '',
            sequence: value.sequence || '',
            multiCurrencyPricing: value.multiCurrencyPricing || [],
            index: this.props.index || 0,
            currency: this.props.currency || '',
            currentCurrency: this.props.currency || '',
            billingMethods: this.props.billingMethods || [],
            pricingStrategy: this.props.pricingStrategy || '',
            unitOfMeasure: this.props.unitOfMeasure || '',
        })
    }

    componentWillReceiveProps(nextProps) {
        const value =  nextProps.value || {}
        this.setState({
            id: value.id || '',
            fromMeasure: value.fromMeasure || '',
            toMeasure: value.toMeasure || '',
            cost: value.cost || '',
            price: value.price || '',
            monthlyCost: value.monthlyCost || '',
            monthlyPrice: value.monthlyPrice || '',
            yearlyCost: value.yearlyCost || '',
            yearlyPrice: value.yearlyPrice || '',
            sequence: value.sequence || '',
            multiCurrencyPricing: value.multiCurrencyPricing?.map(mc => mc.attributes || mc) || [],
            index: nextProps.index || 0,
            billingMethods: nextProps.billingMethods || [],
            pricingStrategy: nextProps.pricingStrategy || '',
            unitOfMeasure: nextProps.unitOfMeasure || '',
        })
    }

    getPriceByBillingMethod(method) {
        return PricingHelper.getPriceByBillingMethod(method, this.state.currency, this.state.currentCurrency, this.state.multiCurrencyPricing, {
            'one-time': this.state.price,
            'monthly': this.state.monthlyPrice,
            'yearly': this.state.yearlyPrice,
        })
    }

    setPriceByBillingMethod(method, price) {
        if (this.state.currency === this.state.currentCurrency) {
            let field = 'price'
            switch (method) {
                case 'monthly':
                    field = 'monthlyPrice'
                    break
                case 'yearly':
                    field = 'yearlyPrice'
                    break
            }
            this.setState({
                [field]: price
            }, () => {
                this.changeValue()
            })
            return
        }
        this.setState({
            multiCurrencyPricing: PricingHelper.setPriceByBillingMethod(price, method, this.state.currentCurrency, this.state.multiCurrencyPricing)
        }, () => {
            this.changeValue()
        })
    }

    handleFormChange(fieldName, newValue) {
        this.setState({
            [fieldName]: newValue
        }, () => {
            this.changeValue()
        })
    }

    deleteValue(e) {
        e.preventDefault()
        const onDelete = this.props.onDelete || function() {}
        onDelete(this.state.index)
    }

    changeValue() {
        const onChange = this.props.onChange || function() {}
        const data = {
            id: this.state.id || uuidv4(),
            fromMeasure: this.state.fromMeasure || '0',
            toMeasure: this.state.toMeasure || '0',
            cost: this.state.cost || '0',
            price: this.state.price || '0',
            monthlyCost: this.state.monthlyCost || '0',
            monthlyPrice: this.state.monthlyPrice || '0',
            yearlyCost: this.state.yearlyCost || '0',
            yearlyPrice: this.state.yearlyPrice || '0',
            sequence: this.state.sequence,
            multiCurrencyPricing: this.state.multiCurrencyPricing || [],
        }
        onChange(this.state.index, data, this.state.currentCurrency)
    }

    handleFocus(event) {
        event.target.select()
    }

    render() {
        const messages = defineMessages({
            "from_placeholder": {
                id: 'product.edit.form.custom_bracket.item.from_placeholder',
                defaultMessage: 'Measure from',
            },
            "to_placeholder": {
                id: 'product.edit.form.custom_bracket.item.to_placeholder',
                defaultMessage: 'Measure to',
            },
            "cost_placeholder": {
                id: 'product.edit.form.custom_bracket.item.cost_placeholder',
                defaultMessage: 'Cost of the bracket',
            },
            "price_placeholder": {
                id: 'product.edit.form.custom_bracket.item.price_placeholder',
                defaultMessage: 'Price of the bracket',
            },
        })

        const pricing = []
        for (let index in this.state.billingMethods) {
            const method = this.state.billingMethods[index]
            let costField = "cost"
            let priceField = "price"
            if (method !== "one-time") {
                costField = method + "Cost"
                priceField = method + "Price"
            }

            pricing.push(<div className="form-row" key={pricing.length}>
                <div className="form-group col-md-6">
                    <label htmlFor={costField}>
                        <BillingMethodCostLabel
                            billingMethod={method}
                            pricingStrategy={this.state.pricingStrategy}
                        />
                    </label>
                    <MoneyInputForm
                        name={costField}
                        value={this.state[costField]}
                        onChange={(newValue) => {this.setState({ [costField]: newValue}, this.changeValue)}}
                    />
                </div>
                <div className="form-group col-md-6">
                    <label htmlFor={priceField}>
                        <BillingMethodPriceLabel
                            billingMethod={method}
                            pricingStrategy={this.state.pricingStrategy}
                        />
                    </label>
                    <MoneyInputForm
                        id={priceField}
                        currency={this.state.currentCurrency}
                        value={this.getPriceByBillingMethod(method)}
                        multiCurrency={true}
                        onChange={(newValue) => {
                            this.setPriceByBillingMethod(method, newValue)
                        }}
                        onCurrencyChange={(newValue) => {
                            this.setState({currentCurrency: newValue})
                            this.changeValue()
                        }}
                    />
                </div>
            </div>)
        }

        return (
            <div className="row p-2 bg-bracket mb-2 rounded">
                <div className="col-12">
                    <div className="form-row">
                        <div className="form-group col-md-6">
                            <label htmlFor="fromMeasure">
                                <FormattedMessage
                                    id="product.edit.form.custom_bracket.item.from_label"
                                    defaultMessage="From"
                                />
                            </label>
                            <InputUnitOfMeasure
                                id="fromMeasure"
                                name="fromMeasure"
                                value={this.state.fromMeasure}
                                unit={this.state.unitOfMeasure}
                                onChange={(newValue) => {
                                    this.handleFormChange("fromMeasure", newValue)
                                }}
                                type="text"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['from_placeholder'])}
                                onFocus={this.handleFocus}
                            />
                        </div>

                        <div className="form-group col-md-6">
                            <label htmlFor="toMeasure">
                                <FormattedMessage
                                    id="product.edit.form.custom_bracket.item.to_label"
                                    defaultMessage="To"
                                />
                            </label>
                            <InputUnitOfMeasure
                                id="toMeasure"
                                name="toMeasure"
                                value={this.state.toMeasure}
                                unit={this.state.unitOfMeasure}
                                onChange={(newValue) => {
                                    this.handleFormChange("toMeasure", newValue)
                                }}
                                type="text"
                                className="form-control"
                                placeholder={this.props.intl.formatMessage(messages['to_placeholder'])}
                                onFocus={this.handleFocus}
                            />
                        </div>
                    </div>
                    {pricing}
                    <div className="form-row">
                        <div className="col-12 text-align-right pb-2">
                            <button className="btn btn-danger btn-sm" onClick={this.deleteValue}>
                                <FormattedMessage
                                    id="product.edit.form.custom_bracket.item.remove_btn"
                                    defaultMessage="Remove"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(PricingBracketForm)


// WEBPACK FOOTER //
// ./src/product/form/custom-bracket/bracket.component.jsx